import notificationsApi from './notificationsApi';

export const getNotifications = async () => {
  const { data } = await notificationsApi.get('/notifications/list');
  return data?.data ?? data;
};

export const markNotificationAsRead = async (id) => {
  const { data } = await notificationsApi.put(`/notifications/${id}`, { isRead: true });
  return data?.data ?? data;
};
